<div class="recap-item pb-4">
    <p class="recap-label">Linea investimento attuale</p>
    <p class="recap-value">{{ actualInvestmentLine }}</p>
</div>

<app-basic-form [form]="form" [keys]="keys"></app-basic-form>